import makeTable from "./makeTable";

export enum ColumnId {
	Online = "online",
	Alias = "alias",
	CarCallSigns = "carCallSigns",
	Status = "status",
	ExecutorGroup = "executorGroup",
	IsWorking = "isWorking",
	Company = "company",
	TaxiService = "taxiService",
}

export const translationTablePath = "orderPageWidgets.executors.modelTable.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

const hiddenColumns = [ColumnId.Company, ColumnId.TaxiService];

export const defaultColumns: ColumnId[] = allColumns.filter(
	(id) => !hiddenColumns.includes(id),
);

const orderWidgetExecutors = makeTable({
	allIds: allColumns,

	i18tPath: (id) => {
		switch (id) {
			case ColumnId.Online:
				return `${translationTablePath}str150`;
			case ColumnId.Alias:
				return `${translationTablePath}str151`;
			case ColumnId.CarCallSigns:
				return `${translationTablePath}str152`;
			case ColumnId.Status:
				return `${translationTablePath}str156`;
			case ColumnId.ExecutorGroup:
				return `${translationTablePath}str153`;
			case ColumnId.IsWorking:
				return `${translationTablePath}str157`;
			case ColumnId.Company:
				return `${translationTablePath}str154`;
			case ColumnId.TaxiService:
				return `${translationTablePath}str155`;
			default:
				return `${translationTablePath}${id}`;
		}
	},

	defaultIds: defaultColumns,

	initialSortMethod: {
		column: ColumnId.Online,
		type: "asc",
	},

	initialWidths: {
		[ColumnId.Online]: 32,
		[ColumnId.Alias]: 55,
		[ColumnId.CarCallSigns]: 55,
		[ColumnId.Status]: 180,
		[ColumnId.ExecutorGroup]: 100,
		[ColumnId.IsWorking]: 130,
		[ColumnId.Company]: 130,
		[ColumnId.TaxiService]: 80,
	},

	initialResizable: {
		[ColumnId.Online]: true,
		[ColumnId.Alias]: true,
		[ColumnId.CarCallSigns]: true,
		[ColumnId.Status]: true,
		[ColumnId.ExecutorGroup]: true,
		[ColumnId.IsWorking]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},

	initialSortable: {
		[ColumnId.Online]: true,
		[ColumnId.Alias]: true,
		[ColumnId.CarCallSigns]: true,
		[ColumnId.Status]: true,
		[ColumnId.ExecutorGroup]: true,
		[ColumnId.IsWorking]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},
});

export default orderWidgetExecutors;
